import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useOutletContext } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { http } from "../lib/http";

/**
 * Guards a route by a module/action permission. Admin always allowed.
 * Falls back to "view" action.
 */
export default function PermGuard({ module, action = "view", children }) {
  const { user } = useAuth();
  const { permissions } = useOutletContext() || {};
  const location = useLocation();

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.role === "admin") return children;
  // Wait for permissions to hydrate. AppShell seeds the outlet with `{}`
  // before the /api/auth/permissions response arrives, so an empty object
  // must NOT be treated as "loaded but lacking permission".
  if (!permissions || Object.keys(permissions).length === 0) return null;
  if (permissions[module]?.[action]) return children;
  return <Navigate to="/403" replace />;
}
